import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
export const TrafficLayer = () => {
    const map = useMap();
    useEffect(() => {
        if (!map)
            return undefined;
        const layer = new google.maps.TrafficLayer();
        layer.setMap(map);
        return () => {
            layer.setMap(null);
        };
    }, [map]);
    return null;
};
